export const settingsWorkDocumentIndexEnUS = {
  settingsWorkDocuments: 'Settings Work Documents',
}

export const settingsWorkDocumentIndexEsMX = {
  settingsWorkDocuments: 'Configuraciones de documentos de trabajo',
}
